/// <reference path="../typings/index.d.ts" />

namespace App.Docs {
    /**
     * Log dedicado ao upload de imagens no admin Docs.
     * No console F12, filtre por: DocsImgUpload
     */
    export class ImageUploadLog {
        private static PREFIX = '[DocsImgUpload]';

        public static info(etapa: string, dados?: any): void {
            if (!window.console || !console.info) {
                return;
            }

            if (dados !== undefined) {
                console.info(ImageUploadLog.PREFIX, etapa, dados);
            } else {
                console.info(ImageUploadLog.PREFIX, etapa);
            }
        }

        public static warn(etapa: string, dados?: any): void {
            if (!window.console || !console.warn) {
                return;
            }

            if (dados !== undefined) {
                console.warn(ImageUploadLog.PREFIX, etapa, dados);
            } else {
                console.warn(ImageUploadLog.PREFIX, etapa);
            }
        }

        public static error(etapa: string, dados?: any): void {
            if (!window.console || !console.error) {
                return;
            }

            if (dados !== undefined) {
                console.error(ImageUploadLog.PREFIX, etapa, dados);
            } else {
                console.error(ImageUploadLog.PREFIX, etapa);
            }
        }

        public static grupo(titulo: string, fn: () => void): void {
            if (!window.console || !console.groupCollapsed) {
                fn();
                return;
            }

            console.groupCollapsed(ImageUploadLog.PREFIX + ' ' + titulo);
            fn();
            console.groupEnd();
        }

        public static servidor(entradas: any[]): void {
            if (!entradas || !entradas.length) {
                return;
            }

            ImageUploadLog.grupo('resposta do servidor (' + entradas.length + ' etapas)', function () {
                for (var i = 0; i < entradas.length; i++) {
                    var entrada = entradas[i];
                    var etapa = entrada && entrada.etapa ? entrada.etapa : 'etapa-' + i;
                    var dados = entrada && entrada.dados ? entrada.dados : entrada;

                    if (dados && dados.erro) {
                        ImageUploadLog.error(etapa, dados);
                    } else {
                        ImageUploadLog.info(etapa, dados);
                    }
                }
            });
        }

        public static verificarUrlImagem(url: string, origem: string): void {
            if (!url) {
                ImageUploadLog.warn('url-vazia', { origem: origem });
                return;
            }

            var contemProcessing = url.indexOf('_processing') !== -1;
            if (contemProcessing) {
                ImageUploadLog.warn('url-contem-processing', { origem: origem, url: url });
            }

            var img = new Image();
            img.onload = function () {
                ImageUploadLog.info('imagem-acessivel-no-navegador', {
                    origem: origem,
                    url: url,
                    largura: img.naturalWidth,
                    altura: img.naturalHeight,
                });
            };
            img.onerror = function () {
                ImageUploadLog.error('imagem-inacessivel-no-navegador', {
                    origem: origem,
                    url: url,
                    contem_processing: contemProcessing,
                });
            };
            img.src = url;
        }

        public static dadosArquivo(file: File, origem: string): void {
            ImageUploadLog.info('arquivo-selecionado', {
                origem: origem,
                nome: file.name || '(sem nome)',
                tipo: file.type || '(sem tipo)',
                tamanho_bytes: file.size,
                ultima_modificacao: file.lastModified || null,
            });
        }
    }
}
